import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doughnut-chart',
  imports: [],
  templateUrl: './doughnut-chart.component.html',
  styleUrl: './doughnut-chart.component.scss',
})
export class DoughnutChartComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
